module.exports = __webpack_public_path__ + "img/demo_thanks.240c832e.png";